import axios from "axios";
import store from "../store";
import { logout, token } from "../reducers/ApplicationSlice";
import { toast } from "react-toastify";

const axiosClient = axios.create();
const { REACT_APP_DATA_API } = process.env;
axiosClient.defaults.baseURL = REACT_APP_DATA_API;

axiosClient.defaults.headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
axiosClient.interceptors.response.use(
  function (response) {
    //updare refresh token
    store.dispatch(token(response.headers["refresh-token"]));
    sessionStorage.setItem("token", response.headers["refresh-token"]);
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      //Add Logic to
      //1. Redirect to login page or
      //2. Request refresh token
      toast.dismiss("loading_data");
      store.dispatch(logout());
      sessionStorage.clear();
    }
    return Promise.reject(error);
  },
);

export function getDataApi(URL) {
  axiosClient.defaults.headers["Authorization"] = "Bearer " + store.getState()["application"]["token"];
  return axiosClient.get(`/${URL}`).then((response) => response);
}

export function postDataApi(URL, payload) {
  axiosClient.defaults.headers["Authorization"] = "Bearer " + store.getState()["application"]["token"];

  return axiosClient.post(`/${URL}`, payload).then((response) => response);
}

export function putDataApi(URL, payload) {
  axiosClient.defaults.headers["Authorization"] = "Bearer " + store.getState()["application"]["token"];

  return axiosClient.put(`/${URL}`, payload).then((response) => response);
}

export function deleteDataApi(URL) {
  axiosClient.defaults.headers["Authorization"] = "Bearer " + store.getState()["application"]["token"];

  return axiosClient.delete(`/${URL}`).then((response) => response);
}

export function fileDataApi(URL, file, data) {
  axiosClient.defaults.headers["Authorization"] = "Bearer " + store.getState()["application"]["token"];
  const form = new FormData();
  form.append("file", file);
  form.append("data", JSON.stringify(data));
  return axiosClient.post(`/${URL}`, form, { headers: { "Content-Type": "multipart/form-data" } }).then((response) => response);
}
